"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityLost = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityLost = class OpportunityLost {
    constructor(opportunityId, activityId, opportunityActivityId, reasonForLossLid, statusLid, remarks) {
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.opportunityActivityId = opportunityActivityId;
        this.reasonForLossLid = reasonForLossLid;
        this.statusLid = statusLid;
        this.remarks = remarks;
    }
};
exports.OpportunityLost = OpportunityLost;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityLost.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "reason_for_loss_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "reasonForLossLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityLost.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityLost.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityLost.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "reason_for_loss_lid" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], OpportunityLost.prototype, "reasonForLoss", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], OpportunityLost.prototype, "status", void 0);
exports.OpportunityLost = OpportunityLost = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_lost"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, String])
], OpportunityLost);
